import { z } from 'zod';

export const NarouTocItemSchema = z.object({
  episodeNumber: z.number().int().nonnegative(),
  url: z.string(),
  title: z.string(),
});

export const NarouTocItemOrChapterSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('chapter'),
    title: z.string(),
  }),
  z.object({
    type: z.literal('episode'),
    episodeNumber: z.number().int().nonnegative(),
    url: z.string(),
    title: z.string(),
  }),
]);

export const NarouNovelInfoSchema = z.object({
  ncode: z.string().regex(/^n[0-9a-z]+$/i, { message: '無効なNコード形式です' }),
  title: z.string().min(1, { message: 'タイトルが必要です' }),
  author: z.string().min(1, { message: '作者名が必要です' }),
  description: z.string().default(''),
  episodes: z.array(NarouTocItemSchema),
  tocItems: z.array(NarouTocItemOrChapterSchema).optional(),
  genre: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  charCount: z.number().nonnegative().optional(),
  status: z.enum(['ongoing', 'completed', 'short']).optional(),
  type: z.enum(['series', 'short']).optional(),
});

export const NarouDetailedMetaSchema = NarouNovelInfoSchema.pick({
  genre: true,
  keywords: true,
  charCount: true,
  status: true,
  type: true,
});
